/**
 * Hosts trusted in dev only — covers localhost backends and ngrok tunnels.
 *
 * Shared between Vite (dev server `allowedHosts`) and the auth-origin guard so
 * the two lists can't drift. Updating ngrok TLDs etc. happens in one place.
 *
 * Why a constant and not config: these aren't per-environment knobs. localhost
 * is always localhost, and ngrok's public TLDs change about once every two years
 * — code review is the right gate for "we now also trust this dev host pattern."
 */
import {
  LOCAL_DALE_HOST_SUFFIXES,
  LOCAL_DALE_LITERAL_HOSTS,
} from "./daleApiUrl.ts";

/** Exact hostnames trusted in dev (no subdomain matching). */
export const DEV_ALLOWED_LITERAL_HOSTS: readonly string[] = [
  ...LOCAL_DALE_LITERAL_HOSTS,
];

/**
 * Suffix-match hostnames (any subdomain). Each entry must start with a leading
 * dot so that `*.foo.com` matches but `evilfoo.com` does not.
 */
export const DEV_ALLOWED_HOST_SUFFIXES: readonly string[] = [
  ...LOCAL_DALE_HOST_SUFFIXES,
];

/** Vite's `server.allowedHosts` accepts both literal hosts and `.suffix` entries. */
export const DEV_VITE_ALLOWED_HOSTS: readonly string[] = [
  ...DEV_ALLOWED_LITERAL_HOSTS,
  ...DEV_ALLOWED_HOST_SUFFIXES,
];
